export const MODULE_PREFIX = 'timeslots';

export const TIMESLOTS_RECEIVED_FORMAT = 'HH.mm.ss';
export const TIMESLOTS_FORMAT = 'hh:mmA';
